import { Modal } from 'antd';
import { type FC } from 'react';
import { ChooseChannelType } from './ui/choose-channel-type/choose-channel-type';
import type { ChannelCreatableType } from '@modules/channels/lib/channel-type';

interface ChannelCreateProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (type: ChannelCreatableType) => void;
}

export const ChannelCreate: FC<ChannelCreateProps> = ({ isOpen, onClose, onSelectType }) => {
  return (
    <Modal
      centered
      open={isOpen}
      onCancel={onClose}
      destroyOnClose
      width="auto"
      styles={{
        content: {
          background: 'var(--color-bg-container)',
          border: '1px solid var(--color-border-soft)',
          borderRadius: 12,
          boxShadow: 'var(--shadow-dropdown)',
        },
        body: {
          background: 'transparent',
        },
      }}
      cancelButtonProps={{ hidden: true }}
      okButtonProps={{ hidden: true }}
    >
      <ChooseChannelType
        selectChooseChannelType={(channelType) => {
          onSelectType(channelType);
          onClose();
        }}
      />
    </Modal>
  );
};
